import { Route } from '../../../enums';
import { useDoctorLoginBoxEffect } from './doctor-login-page-box.effect';
import Link from 'next/link';
import { ToastMolecule } from '../../molecules';
import React from 'react';
import { useLoginPageStyles } from '../../../styles/pages/login-page.styles';

export const DoctorLoginPageBoxOrganism = () => {
  const classes = useLoginPageStyles();
  const { members, onSubmit, error } = useDoctorLoginBoxEffect();

  return (
    <div
      data-cy="login-page-box"
      className={`w-11/12 mx-auto flex flex-col items-center justify-center ${classes.heightCalc}`}
    >
      <div className="mb-10 mx-auto md:max-w-2xl">
        <h3 className="font-medium font-waldo-sans text-center text-white text-4xl">
          Hey there!
        </h3>
      </div>
      <form onSubmit={onSubmit} className="w-full block">
        {error && (
          <div className="text-waldo-tangerine text-sm font-medium mb-5">
            <ToastMolecule
              toastList={[
                {
                  id: 1,
                  title: 'Login Failed!',
                  description: error,
                  bgColor: 'bg-waldo-poppy',
                  icon: 'warning',
                },
              ]}
              position="Bottom-Right"
              autoDelete={true}
              autoDeleteTime={8000}
            />
          </div>
        )}
        <div className="mx-auto px-6 max-w-2xl">
          <div
            className={`w-full flex flex-col items-center ${classes.inputStyles}`}
          >
            <div className={'w-full md:w-1/2'}>
              <label
                htmlFor="member-username"
                className="text-white ml-4 text-sm font-normal hidden"
              />
              <input
                className={`my-0.5 input-login mb-5 ${
                  !members.username.isClean && !members.username.isValid
                    ? 'input-error-border'
                    : ''
                }`}
                type="text"
                id="member-username"
                placeholder="Email*"
                onChange={(e) => members.username.onChange(e.target.value)}
                onFocus={() => members.username.onFocus()}
                onBlur={() => members.username.onBlur()}
              />
              {!members.username.isClean && !members.username.isValid && (
                <div className="absolute top-2 right-4 text-sm text-waldo-poppy">
                  {members.username.errors[0]}
                </div>
              )}
            </div>
            <div className="w-full md:w-1/2">
              <label
                htmlFor="member-password"
                className="text-white ml-4 text-sm font-normal hidden"
              />
              <input
                className={`my-0.5 input-login w-full mb-5 ${
                  !members.password.isClean && !members.password.isValid
                    ? 'input-error-border'
                    : ''
                }`}
                type="password"
                id="member-password"
                placeholder="Password*"
                onChange={(e) => members.password.onChange(e.target.value)}
                onFocus={() => members.password.onFocus()}
                onBlur={() => members.password.onBlur()}
              />
              {!members.password.isClean && !members.password.isValid && (
                <div className="absolute top-2 right-4 text-sm text-waldo-poppy">
                  {members.password.errors[0]}
                </div>
              )}
            </div>
            <button className="button btn-secondary-cta py-5 mt-5 font-normal w-full hover:bg-white hover:border-white hover:text-waldo-blue md:w-2/5">
              Sign in
            </button>
            <Link href={Route.PATIENT_REGISTER}>
              <a className="mt-2.5 mb-1.5 text-white md:text-lg">
                Forgot password?
              </a>
            </Link>
          </div>
        </div>
      </form>
    </div>
  );
};
